import App from 'app/app.js';
import 'app/directive/LtConfirmDeleteDrawerCtrl.js';

function LtConfirmDeleteDrawerDirective() {
  return {
    restrict: 'E',
    scope: {
      onInit: '&',
      onAnswer: '&',
      onCancellation: '&',
      deleteConfirmationMessage: '@'
    },
    template:
      '	<div class="bottom-drawer bottom-drawer-alignment"  ng-init="confirmDeleteDrawer.init()" lt-drawer="confirmDeleteDrawer.visible" lt-drawer-cancellation="confirmDeleteDrawer.cancel()">' +
      '	    <div id="most-popular-cont">' +
      '	        <h5 class="text-center"><b ng-bind="deleteConfirmationMessage"></b></h5>' +
      '	        <div class="row">' +
      '	            <div class="col-xs-12">' +
      '	                <a id="do-delete-btn" ng-click="confirmDeleteDrawer.answer(true);" class="btn blue" lt-translate="CART_CONTENTS_CONFIRM_DELETE_BUTTON" data-id="button" ></a>' +
      '	            </div>' +
      '	        </div>' +
      '	        <div align="center" class="row cancel-link-pad">' +
      '	            <div class="cancelSprite">' +
      '	                <a id="do-cancel-btn"  ng-click="confirmDeleteDrawer.close()" lt-translate="COMMON_TEXT_CANCEL" data-id="button" ></a>' +
      '	            </div>' +
      '	        </div>' +
      '	    </div>' +
      '	</div>',
    controller: 'LtConfirmDeleteDrawerCtrl',
    controllerAs: 'confirmDeleteDrawer'
  };
}

App.directive('ltConfirmDeleteDrawer', [LtConfirmDeleteDrawerDirective]);
